<template>
  <div class="subsystem">
    <div class="subsystem-body">
      <div class="ss-title">子系统监测</div>
      <div class="list">
        <div v-for="item in filterSystems" 
             :key="item.clientId" 
             class="item" 
             @touchstart="handleSystemClick(item)"
             @click="handleSystemClick(item)">
          <img class="img" :src="getSystemIcon(item.appName)" alt="">
          <div class="item-title">{{ item.appName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSystematicByParent } from "@/network/systematic";
import {getResourceList} from "@/network/resource";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "Subsystem",
  mixins: [platenLayoutEdit],
  data() {
    return {
      systemList: [],
      // 系统图标映射配置
      systemMapping: {
        '能效': {
          icon: require('@/assets/images/nhsys.png'),
          keywords: ['能效', '能源', '能耗'],
          order: 1
        },
        '工单': {
          icon: require('@/assets/images/gdsys.png'),
          keywords: ['工单'],
          order: 2
        },
        '资产': {
          icon: require('@/assets/images/xjsys.png'),
          keywords: ['资产', '巡检'],
          order: 3
        },
        '预约': {
          icon: require('@/assets/images/wlsys.png'),
          keywords: ['预约', '物联'],
          order: 4
        },
        '群控': {
          icon: require('@/assets/images/qksys.png'),
          keywords: ['群控', 'BA'],
          order: 5
        },
        '电力': {
          icon: require('@/assets/images/dlsys.png'),
          keywords: ['电力'],
          order: 5
        },
        'ptms': {
          icon: require('@/assets/images/ptms.png'),
          keywords: ['ptms', 'PTMS'],
          order: 5
        },
      }
    }
  },
  computed: {
    filterSystems() {
      // 创建数组副本后再排序
      return [...this.systemList].sort((a, b) => {
        const orderA = this.getSystemOrder(a.appName);
        const orderB = this.getSystemOrder(b.appName);
        return orderA - orderB;
      });
    }
  },
  mounted() {
    this.getLinkage();
  },
  methods: {
    // 获取子系统数据
    getLinkage() {
      getSystematicByParent().then(res => {
        // 获取第一组系统数据
        let systemData = [];
        if (res && Array.isArray(res.data)) {
          systemData = res.data;
        }
        
        // 获取资源列表
        getResourceList().then(resourceRes => {
          if (resourceRes.code === 0) {
            let menus = resourceRes.data.resources.filter(item => item.superId === '0');
            let filteredMenus = [];
            
            // 过滤匹配的菜单项
            for(let i = 0; i < menus.length; i++) {
              if (menus[i].navUrl === 'electricity' || 
                  menus[i].navUrl === 'group-control' || 
                  menus[i].navUrl === 'ptms-cabinet') {
                
                // 确保每个菜单项都有appName属性
                if (!menus[i].appName && menus[i].cnName) {
                  menus[i].appName = menus[i].cnName;
                } else if (!menus[i].appName) {
                  menus[i].appName = '未命名系统';
                }
                
                // 添加缺少的website和goRouter属性
                menus[i].goRouter = 'href';
                
                // 根据navUrl设置对应的website
                switch(menus[i].navUrl) {
                  case 'electricity':
                    menus[i].website = '#/electricity';
                    break;
                  case 'group-control':
                    menus[i].website = '#/group-control';
                    break;
                  case 'ptms-cabinet':
                    menus[i].website = '#/ptms-cabinet';
                    break;
                }
                
                filteredMenus.push(menus[i]);
              }
            }
            
            // 合并所有系统数据
            this.systemList = [...systemData, ...filteredMenus];
            console.log(this.systemList, 'systemList');
          }
        }).catch(err => {
          console.error('获取资源列表失败:', err);
          this.systemList = systemData;
        });
      }).catch(err => {
        console.error('获取子系统数据失败:', err);
        this.systemList = [];
      });
    },

    // 获取系统图标（模糊匹配）
    getSystemIcon(appName) {
      // 添加防御性检查
      if (!appName) return this.systemMapping['能效'].icon;
      
      for (const [, value] of Object.entries(this.systemMapping)) {
        if (value.keywords.some(keyword => 
          String(appName).toLowerCase().includes(keyword.toLowerCase()))) {
          return value.icon;
        }
      }
      // 默认返回能效系统图标
      return this.systemMapping['能效'].icon;
    },

    // 获取系统排序（模糊匹配）
    getSystemOrder(appName) {
      // 添加防御性检查
      if (!appName) return 999;
      
      for (const [, value] of Object.entries(this.systemMapping)) {
        if (value.keywords.some(keyword => 
          String(appName).toLowerCase().includes(keyword.toLowerCase()))) {
          return value.order;
        }
      }
      return 999;
    },

    // 处理系统点击
    handleSystemClick(system) {
      if (this.isPlatenLayoutEditing) return
      if (!system.website) {
        this.$message.warning('系统链接未配置');
        return;
      }
      
      if (system.goRouter === 'href') {
        // 从 website 中移除 # 符号，因为 Vue Router 不需要它
        const path = system.website.replace('#', '');
        return this.$router.push({
          path: path  // 使用 path 而不是 name
        });
      }
      
      window.open(system.website, '_blank');
    }
  }
}
</script>

<style scoped>
.subsystem {
  width: 100%;
  height: 100%;
}

.subsystem-body{
  width: 100%;
  height: 100%;
  padding: 5% 3% 15% 10%;

}

.subsystem-body .ss-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 1.1rem;
  color: #00E3F6;
  margin-bottom: 8%;
}
.subsystem-body .list{
  display: flex;
  flex-wrap: wrap;
}
.subsystem-body .list .item {
  z-index: 1;
  width: 50%;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.9rem;
}
</style>